
import { deleteFreqContactApi, getMemberInfoApi, saveFreqContactApi, saveMemberInfoApi, getOrderPendingPayApi } from '@/apis/common';

// 会员信息接口调用
export const getMemberInfo = async () => {
	const res = await getMemberInfoApi();
	return res.data;
};

export const saveMemberInfoFun = async (params: any) => {
	const res = await saveMemberInfoApi(params);
	return res;
};

export const deleteFreqContactFun = async (params: any) => {
	const res = await deleteFreqContactApi(params);
	return res;
};

export const saveFreqContactFun = async (params: any) => {
	const res = await saveFreqContactApi(params);
	return res;
};

export const getCountryNameFun = (countryList: any[], countryCode: string, lang: string) => {
	console.log(countryList, countryCode, lang);
	for (const i in countryList) {
		if (countryList[i].countryCode === countryCode) {
			return countryList[i]['country' + lang];
		}
	}
};
// 获取待支付订单数量
export const getOrderPendingPayApiFun = async (params: any) => {
	const res = getOrderPendingPayApi(params);
	return res;
};